import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import baseUrl from '../../components/baseUrl'
import Nav from '../../components/Nav/Nav'
import login_pic from './assets/login_pic.jpg'
import google from './assets/google.svg'
import Footer from '../../components/Footer/Footer'
// import './LogIn.css'
import { useNavigate } from 'react-router-dom'
import ForgotPassword from './ForgotPassword'
import { useGoogleLogin } from '@react-oauth/google';

import errorIcon from '../../components/assets/error.svg'
import codeSentIcon from '../../components/assets/codeSent.svg'
import VerifyOTP from '../../components/VerifyOTP/VerifyOTP'
import { setRawToken } from '../../utils/auth'; // import both


const LogIn = ({fetchSavedVendorsData}) => {
  const [forgotPasswordSteps, setForgotPasswordSteps] = useState(-1)
  const [enterOTP, setEnterOTP] = useState(false)
  const [isHeroku, setisHeroku] = useState(false)
  const [correctOtp, setCorrectOtp] = useState('')
  const [progressBar, setProgressBar] = useState(0)
  const [loading, setLoading] = useState(false); // Track loading state

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Smooth scrolling behavior
    });
  };


  const [errorMessage, setErrorMessage] = useState("")
  const [alertMessage, setAlertMessage] = useState("")
  const [restRequestError, setRestRequestError] = useState("")
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [showPassword, setShowPassword] = useState(false)
  const [forgotPassword, setForgotPassword] = useState(0)
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState("")
  const navigate = useNavigate()

  const [seconds, setSeconds] = useState(9 * 60 + 59);

  const [newPassword, setNewPassword] = useState("")
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [confirmPassword, setConfirmPassword] = useState("")
  const [newPassError, setNewPassError] = useState("")
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  const [googleTokenResponse, setGoogleTokenResponse] = useState()
  const [strength, setStrength] = useState(0);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };



  // Encode the data before storing it
  function encodeData(data) {
    return btoa(data); // Base64 encoding
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true); // Set loading to true when the request starts

    const data = JSON.stringify({
      email: email ? email.toLowerCase() : "",
      password: password
    });

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${baseUrl}/auth/login`,
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    };

    try {
      const response = await axios.request(config);
      // const token = response?.data?.token;
      const token = response && response.data && response.data.token;

      if (token) {
        setRawToken(token);
        window.localStorage.setItem("jdgbgiusudgfdyudbudvfudhfgbiyfudvifiudubuydfbduvuydfvuy", encodeData(JSON.stringify(token)));
        await fetchSavedVendorsData(token);
        navigate("/dashboard");

      } else {
        setErrorMessage(response?.data?.message);
      }
    } catch (error) {
      // const errorMessage = error?.response?.data?.msg || "An error occurred.";
      const errorMessage = error && error.response && error.response.data && error.response.data.msg || "An error occurred.";
      setErrorMessage(errorMessage);

      if (errorMessage === "Your password needs to be reset. A reset OTP has been sent to your email.") {
        // setErrorMessage("Email not verified");
        setisHeroku(true)
        setTimeout(() => {
          setErrorMessage("");
          setAlertMessage("A new OTP has been sent to your email.");
          setTimeout(() => {
            setAlertMessage('');
            setEnterOTP(true);
          }, 2000);
        }, 3000);
      }
    } finally {
      setLoading(false); // Set loading to false after request is completed
    }
  };


  const tester = (value) => {
    let criteriaMet = 0;

    if (value.length >= 8) criteriaMet++;
    if (/[A-Z]/.test(value)) criteriaMet++;
    if (/[a-z]/.test(value)) criteriaMet++;
    if (/\d/.test(value)) criteriaMet++;
    if (/[!@#$%^&*]/.test(value)) criteriaMet++;

    return criteriaMet
  }

  const newPasswordOnChange = (value) => {
    setNewPassword(value)
    setStrength(tester(value));
  }

  useEffect(() => {
    const timer = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
    }, 1000);

    return () => {
      clearInterval(timer);
      // document.body.removeChild(script);
    };

  }, [seconds, googleTokenResponse]);


  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  // Format the time to display leading zeros (e.g., 05:03)
  const formattedTime = String(minutes).padStart(2, '0') + ':' + String(remainingSeconds).padStart(2, '0');
  // console.log(window.innerHeight);
  // console.log('isHeroku', isHeroku)
  const handleGoogleLogin = () => {
    // Backend should redirect to: https://your-frontend.com/auth/callback?token=...
    window.location.href = `${baseUrl}/social-auth/google`;
  };

  return (
    <div className='lg:min-h-screen flex flex-col justify-between'>
      <Nav />
      <div className={` login flex flex-col-reverse lg:flex-row  items-center lg:justify-between lg:gap-[56px] mg:gap-[60px] xl:gap-[122px] pt-[95px] sm:pt-[112px] lg:pt-[16vh] mg:pt-[14vh] lg:pl-[73px] mg:pl-[102px] xl:pl-[161px] `}>
        <div className="lg:flex-1 lg:flex lg:justify-center lg:items-center self-center">

          <div className='bg-white lg:bg-none  rounded-t-[30px] sm:rounded-t-40px left-0 right-0  px-[24px] md:px-[132px] pt-[37px] pb-[24px] lg:pb-0 sm:pt-[67px] lg:pt-0 lg:px-0 absolute bottom-0 lg:relative h-[65vh] sm:h-[55vh] lg:h-auto  lg:py-0 z-20 w-full lg:w-min-[700px] shadow-input lg:shadow-none sm:rounded-t-[40px] md:px-[132px]'>
            {enterOTP === true ?
              <VerifyOTP verifyType="email" setCorrectOtp={setCorrectOtp} setEnterOTP={setEnterOTP} setForgotPasswordSteps={setForgotPasswordSteps} email={email} setProgressBar={setProgressBar} isHeroku={setisHeroku} />

              :
              forgotPasswordSteps === -1 ?
                <>
                  <button onClick={handleGoogleLogin} className=' w-full h-[40px] lg:h-[50px] border-[1px] border-ravgray1 rounded-[80px] flex items-center justify-center'>
                    <img src={google} alt="" />
                    <h1 className=' text-ravinput text-base lg:text-sm font-bold ml-[9px] lg:ml-[13px]'>Sign in with Google</h1>
                  </button>
                  <form onSubmit={handleSubmit} className=' lg:flex-1 flex flex-col justify-center items-center text-center '>
                    {/* <button className=' w-full h-[40px] lg:h-[50px] border-[1px] border-ravgray1 rounded-[80px] flex items-center justify-center'>
                    <img src={google} alt="" />
                    <h1 className=' text-ravinput text-base lg:text-sm font-bold ml-[9px] lg:ml-[13px]'>Sign in with Google</h1>
                  </button> */}
                    <h1 className=' font-bold my-[15px] lg:my-[30px] text-ravinput text-xs lg:text-sm'>LOGIN WITH EMAIL</h1>

                    {/**Message div */}
                    <div className={` ${errorMessage?.length == 0 && alertMessage?.length == 0 ? "hidden" : "flex"} w-full flex-col gap-6 mb-[18px]`}>
                      {errorMessage?.length > 0 ? <h1 className={`bg-[#FFDFE4]  text-[#EB0728]  h-[30px] flex justify-center items-center text-center rounded-[20px]  w-full text-[10px] leading-[12.13px]`}>
                        <img src={errorIcon} alt="" className='size-[14px] mr-1' />
                        {errorMessage}
                      </h1> : null}

                      {alertMessage?.length > 0 ? <h1 className={`bg-[#D6FBC9] text-[#4FBF26]  h-[30px] flex justify-center items-center text-center rounded-[20px] w-full text-[10px] leading-[12.13px]`}>
                        <img src={codeSentIcon} alt="" className='size-[14px] mr-1' />
                        {alertMessage}
                      </h1> : null}
                    </div>

                    <input value={email} onChange={(e) => setEmail(e.target.value)} required type="email" name="email" id="email" placeholder='Email' className=' pl-[30px] h-[45px] lg:h-[50px] w-full rounded-[80px] placeholder:text-ravinput  text-base bg-ravbg outline-ravblue font-medium' />
                    <div className="relative w-full mt-[15px]">
                      <input type={showPassword ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} name="password" id="password" placeholder="Password" required className="pl-[30px] pr-[50px] h-[45px] lg:h-[50px] w-full rounded-[80px] placeholder:text-ravinput  text-base bg-ravbg outline-ravblue font-medium" />
                      <button type="button" onClick={togglePasswordVisibility} className="absolute right-5 top-1/2 -translate-y-1/2 flex items-center">
                        {showPassword ? (
                          //Eye-off icon
                          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" className="fill-[#AAAAAA]">
                            <path d="m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z" />
                          </svg>
                        ) : (
                          //Eye icon
                          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" className="fill-[#AAAAAA]">
                            <path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z" />
                          </svg>
                        )}
                      </button>
                    </div>

                    <button onClick={() => { setForgotPasswordSteps(0); scrollToTop(); setErrorMessage('') }} className='pl-[30px] flex self-baseline mt-[8px] font-medium text-ravinput text-xs hover:text-opacity-70 transform transition-all ease-in-out duration-300'>Forgot Password?</button>
                    <button
                      type='submit'
                      className={`relative hover:opacity-70 mt-[18px] ${loading ? 'bg-[#A2CEFF]' : 'bg-ravblue'
                        }  text-[#FFFFFF] text-sm font-bold w-full h-[45px] lg:h-[50px] rounded-[80px] flex items-center justify-center transform transition-all ease-in-out duration-300`}
                      disabled={loading} // Disable the button while loading
                    >
                      {/* Spinner overlay */}
                      {loading ? (
                        <AiOutlineLoading3Quarters className="absolute animate-spin" />)

                        : (<span>
                          Login
                        </span>
                        )}
                    </button>

                    <h1 className=' text-ravinput text-xs sm:text-base font-medium mt-[15px]'>Are you new here?  <button onClick={() => navigate("/signup")} className=' hover:text-opacity-70 text-ravblue font-bold transform transition-all ease-in-out duration-300'>Sign up</button></h1>
                  </form>
                </>
                :
                <ForgotPassword forgotPasswordSteps={forgotPasswordSteps} setForgotPasswordSteps={setForgotPasswordSteps} scrollToTop={scrollToTop} correctOtp={correctOtp} setCorrectOtp={setCorrectOtp} setEnterOTP={setEnterOTP} progressBar={progressBar} setProgressBar={setProgressBar} />
            }
          </div>
        </div>

        <div className='lg:flex sm:flex-1 px-[24px] w-auto sm:px-[32px] lg:px-0 lg:w-auto  lg:min-h-[50vh] lg:min-w-[504px] mg:min-w-[567px] xl:min-w-[667px]'>
          <img
            src={login_pic}
            alt="login_pic"
            className=' w-full  relative z-10 object-cover rounded-t-[20px] sm:rounded-t-[50px] lg:rounded-l-[50px] lg:rounded-r-none  sm:max-h-screen xl:max-h-[72vh] '
          />
        </div>
      </div>

      <div className='hidden lg:block'>
        <Footer />
      </div>

    </div>
  )
}

export default LogIn


